import { SchemaType } from './VariableSchema';

export function getSchemaTypeName(type: SchemaType | undefined) {
    switch (type?.toLowerCase()) {
        case SchemaType.String.toLowerCase(): return FRENDS.Localizations.EnvironmentVariables_DatatypeText;
        case SchemaType.Number.toLowerCase(): return FRENDS.Localizations.EnvironmentVariables_DatatypeNumber;
        case SchemaType.Boolean.toLowerCase(): return FRENDS.Localizations.EnvironmentVariables_DatatypeYesNo;
        case SchemaType.Secret.toLowerCase(): return FRENDS.Localizations.EnvironmentVariables_DatatypeSecret;
        case SchemaType.Array.toLowerCase(): return FRENDS.Localizations.EnvironmentVariables_DatatypeList;
        case SchemaType.Object.toLowerCase(): return FRENDS.Localizations.EnvironmentVariables_DatatypeGroup;
        default: return "Unknown type";
    }
}
